import React, { useState, useEffect } from 'react';
import { useAccount, useWriteContract, useReadContract } from 'wagmi';
import ConnectAccount from '../components/ConnectAccount';
import { abi } from './PaymentMethodAbi';

const PaymentRegistryAddress = process.env.NEXT_PUBLIC_PAYMENT_METHODS_CONTRACT_ADDRESS as `0x${string}` | null;


interface AddNewTokenProps {
    handleDidClose: () => void;
}

export default function AddNewToken(props: AddNewTokenProps) {
    const { handleDidClose } = props;
    const account = useAccount();
    const [tokenAddress, setTokenAddress] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const {
        status: addTokenStatus,
        writeContract,
        data: transactionHash,
        isSuccess: transactionIsSuccess
    } = useWriteContract();

    const { data: fee } = useReadContract({
        address: PaymentRegistryAddress || undefined,
        abi,
        functionName: 'addNewCoinFee',
    });

    const handleAddToken = async () => {
        if (!PaymentRegistryAddress || !tokenAddress || isSubmitting || !fee) {
            return;
        }

        setIsSubmitting(true);
        try {
            await writeContract({
                address: PaymentRegistryAddress,
                abi,
                functionName: 'addNewCoin',
                args: [tokenAddress as `0x${string}`],
                value: fee,
            });
        } catch (error) {
            console.error('Failed to add token:', error);
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (addTokenStatus === 'error') {
            setIsSubmitting(false);
        }
    }, [addTokenStatus]);

    const addButtonClasses = tokenAddress && !isSubmitting
        ? 'mt-4 py-2 px-8 border border-gray-400 rounded-md bg-gray-200 hover:bg-gray-100 text-gray-800'
        : 'mt-4 py-2 px-8 border border-gray-100 border-2 text-gray-400 rounded-md bg-gray-200 cursor-not-allowed';

    return (
        <div className="relative flex flex-col items-center justify-around bg-gray-800 text-white p-6 shadow-lg">
            <h1 className='font-medium text-3xl md:text-5xl my-20 text-center'>Add A New Coin</h1>

            <div className='text-base leading-loose text-center px-2 mb-12'>
                Add a new payment method for Stickers and Objectives.<br />
                The coin must be an ERC20 on Base.<br />
            </div>

            <div className='w-full max-w-md bg-gray-700 rounded-lg p-6'>
                <div className='flex flex-col gap-4'>
                    <label className='text-sm text-gray-300'>Contract Address</label>
                    <input
                        type="text"
                        value={tokenAddress}
                        onChange={(e) => setTokenAddress(e.target.value)}
                        className='p-2 rounded bg-gray-600 text-white'
                        placeholder='0x...'
                    />
                    <button
                        disabled={!tokenAddress || isSubmitting}
                        onClick={handleAddToken}
                        className={addButtonClasses}
                    >
                        {isSubmitting ? 'Adding...' : 'Add Token'}
                    </button>
                </div>
            </div>

            <div className='mt-14 p-0 w-full text-center leading-8'>
                <h2 className='text-2xl'>Connect Wallet</h2>
                <ConnectAccount />
            </div>

            <div className='fixed top-2 right-2'>
                <button
                    onClick={handleDidClose}
                    className="text-slate-800 m-4 py-1 px-3 text-2xl bg-slate-100 hover:bg-slate-300 rounded-full"
                >
                    X
                </button>
            </div>
        </div>
    );
}
